module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('sk-container', {
    staticClass: "sk-club__section"
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', {
    staticClass: "static-info--heading"
  }, [_vm._v("SK Subscription Club "), _c('span', [_vm._v("(Only available in South Africa)")])]), _vm._v(" "), _c('h3', [_vm._v("Get the most out of all ster-kinekor movie benefits")])]), _vm._v(" "), _c('sk-panel', [_c('sk-layout', {
    staticClass: "subs-club-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("SK Subscription Club")]), _vm._v(" "), _c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('p', [_vm._v("Join SK Subscription Club to get more than you paid for today!")]), _vm._v(" "), _c('p', [_vm._v("\n                            As a SK Subscription Club member, you can get a subscription for a Limited or Unlimited \n                            amount of movies per month at a set cost, which you pay per month. This means \n                            you can now watch more movies at a lower price, whilst also enjoying the benefits \n                            of the SK Club\n                        ")])])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-club-cards.png",
      "alt": ""
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__section sk-club__join-steps"
  }, [_c('sk-panel', [_c('h2', {
    staticClass: "sk-club__points--heading"
  }, [_vm._v("Subscription and Pricing")]), _vm._v(" "), _c('h4', [_vm._v("Get the subscription plan that is right for you.")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('sk-flex', {
      key: item.Description,
      staticClass: "subs-club-options",
      attrs: {
        "xs12": "",
        "sm12": "",
        "md6": ""
      }
    }, [(item.Description == 'Limited Subs') ? [_c('div', {
      staticClass: "limited-subs"
    }, [_c('div', {
      staticClass: "img-container"
    }, [_c('img', {
      staticClass: "img-responsive fan-img img-option",
      attrs: {
        "src": "/static/img/fan_club_card.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "sk-club__join-steps--heading"
    }, [_vm._v("LIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('h4', [_vm._v("Get 4 2D or 3D movie tickets per month for you and your family.")]), _vm._v(" "), _c('div', {
      staticClass: "sk-club__join"
    }, [_c('h2', {
      staticClass: "h1"
    }, [_vm._v(_vm._s(item.Price) + " "), _c('span', [_vm._v("p/month")])])]), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-limited-tickets-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                        You watch more for less\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-combo-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                        20% off a regular combo\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-limited-users-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n                                        Use one or all four tickets at once\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-location-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "sk-club__join-steps--btns"
    }, [(_vm.user != undefined && _vm.user != null && !_vm.user.isGuest()) ? [(_vm.user.PreferenceList.includes(6)) ? [_c('sk-button', {
      staticClass: "sk-club__join-steps--join-btn",
      attrs: {
        "primary": "",
        "tag": "a",
        "href": "/user/profile"
      }
    }, [_vm._v("MY CURRENT SUBSCRIPTION")])] : [(!_vm.user.PreferenceList.includes(5)) ? [_c('sk-button', {
      staticClass: "sk-club__join-steps--join-btn",
      attrs: {
        "primary": "",
        "dataContext": "Subscription Funnel",
        "dataValue": "Join Fan Club"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setSubsOption(item.Id)
        }
      }
    }, [_vm._v("JOIN FAN CLUB NOW")])] : _vm._e()]] : [_c('sk-button', {
      staticClass: "sk-club__join-steps--join-btn",
      attrs: {
        "primary": "",
        "dataContext": "Subscription Funnel",
        "dataValue": "Join Fan Club"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setSubsOption(item.Id)
        }
      }
    }, [_vm._v("JOIN FAN CLUB NOW")])]], 2)], 1)] : _vm._e(), _vm._v(" "), (item.Description == 'Unlimited Subs') ? [_c('div', {
      staticClass: "unlimited-subs"
    }, [_c('div', {
      staticClass: "img-container"
    }, [_c('img', {
      staticClass: "img-responsive img-option",
      attrs: {
        "src": "/static/img/morvies_club_card.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "sk-club__join-steps--heading"
    }, [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('h4', [_vm._v("Watch as many 2D or 3D movies as you want all month long.")]), _vm._v(" "), _c('div', {
      staticClass: "sk-club__join"
    }, [_c('h2', {
      staticClass: "h1"
    }, [_vm._v(_vm._s(item.Price) + " "), _c('span', [_vm._v("p/month")])])]), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                        Watch up to 5 movies a day, every day!\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-combo-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                        20% off a regular combo\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-unlimited-users-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n                                        1 ticket per movie per card holder\n                                        \n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-location-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "sk-club__join-steps--btns"
    }, [(_vm.user != undefined && _vm.user != null && !_vm.user.isGuest()) ? [(_vm.user.PreferenceList.includes(5)) ? [_c('sk-button', {
      staticClass: "sk-club__join-steps--join-btn",
      attrs: {
        "primary": "",
        "tag": "a",
        "href": "/user/profile"
      }
    }, [_vm._v("MY CURRENT SUBSCRIPTION")])] : [(!_vm.user.PreferenceList.includes(6)) ? [_c('sk-button', {
      staticClass: "sk-club__join-steps--join-btn",
      attrs: {
        "primary": "",
        "dataContext": "Subscription Funnel",
        "dataValue": "Join Morvies Club"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setSubsOption(item.Id)
        }
      }
    }, [_vm._v("JOIN MORVIES CLUB NOW")])] : _vm._e()]] : [_c('sk-button', {
      staticClass: "sk-club__join-steps--join-btn",
      attrs: {
        "primary": "",
        "dataContext": "Subscription Funnel",
        "dataValue": "Join Morvies Club"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setSubsOption(item.Id)
        }
      }
    }, [_vm._v("JOIN MORVIES CLUB NOW")])]], 2)], 1)] : _vm._e()], 2)
  }))], 1)], 1), _vm._v(" "), _c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('sk-layout', {
    staticClass: "subs-club-benefits",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_c('h2', [_vm._v("Be one of the first")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("\n                            Experience the brand-new way of enjoying movies and cinema.\n                            Valid for the standard 2D and 3D shows only\n                        ")]), _vm._v(" "), _c('div', [_vm._v("Available for online bookings")])])])], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('h3', [_vm._v("EACH TICKET GETS YOU")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v("20% OFF A REGULAR COMBO")])])])])], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_c('h2', [_vm._v("SK CLUB BENEFITS")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("\n                            By being part of Subscription Club you will automatically be eligible for SK Club benefits!\n                            So not only can you watch more movies for less, but you get points every time you do.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "fine-print"
  }, [_vm._v("T's & C's apply (60+ do not earn points)")])])])], 1)], 1)], 1), _vm._v(" "), _c('sk-panel', [_c('sk-layout', {
    staticClass: "subs-club-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("READY TO JOIN? FOLLOW 3 EASY STEPS.")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h5', [_vm._v("Don't have an SK profile? Create one now")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Choose a pricing option.")]), _vm._v(" "), _c('li', [_vm._v("Create a SK profile to join.")]), _vm._v(" "), _c('li', [_vm._v("Make your first payment and complete debit order details.")])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2848b0d3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/subs-club/subs-club.vue
// module id = 705
// module chunks = 0